import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=bedaaca6&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=bedaaca6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedaaca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedaaca6')) {
      api.createRecord('bedaaca6', component.options)
    } else {
      api.reload('bedaaca6', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=bedaaca6&scoped=true", function () {
      api.rerender('bedaaca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/faq.vue"
export default component.exports